import { Role } from "./../../../../store/session/session.store";
import { PageControl } from "./../../../../shared/model/page-control";
import { IdName } from "@app-services/oem-dealer.service";
export class UserFilter {
  dealerId?: string;
  oemDealerId?: string;
  accessProfileId?: string;
  accessProfileIds?: string[];
  evalDealerIds?: string[];
  oemDealerLocationIds?: string[];
  pageControl?: PageControl;
  searchQuery?: string;
  inactive?: boolean;
  onlyActive?: boolean;
  onlyInactive?: boolean;
  roles?: string[];
  constructor() {
    this.pageControl = new PageControl();
  }
}

export class UserFilterOptions {
  accessProfiles?: IdName[];
  evalDealers?: IdName[];
  locations?: IdName[];
}

export class UserList {
  actualPage?: number;
  data?: UserItem[];
  numberOfPages?: number;
  totalElements?: number;
}
export class UserItem {
  email?: string;
  id?: string;
  inactive?: boolean;
  lastAccess?: string;
  name?: string;
  registered?: boolean;
  roles?: string[];
  phoneNumber?: string;
  cpf?: string;
  evalDealers: IdName[];
  oemDealerLocations: IdName[];
  whatsappNumber: string;
  externalId: string;
  accessProfileId?: string;
  accessProfile?: UserAccessProfile;
}

export class UserAccessProfile {
  id?: string;
  oemDealerId?: string;
  name?: string;
  color?: string;
  systemProfile?: boolean;
  inactive?: boolean;
  usersCount?: number;
}

export class OptionLabel {
  constructor(
    public label: string,
    public value: string,
    public selected: boolean = false
  ) { }
}

export interface UserCsvImportIssue {
  line: number;
  field?: string;
  email?: string;
  code: string;
}

export interface UserCsvImportResponse {
  totalProcessed: number;
  created: number;
  updated: number;
  ignored: number;
  issues: UserCsvImportIssue[];
  failures: UserCsvImportIssue[];
  warnings: UserCsvImportIssue[];
  fileErrorCode?: string;
}

export interface UserCsvImportApiResponse {
  processed?: number;
  totalProcessed?: number;
  created?: number;
  updated?: number;
  errors?: number;
  ignored?: number;
  failures?: UserCsvImportApiIssue[];
  warnings?: UserCsvImportApiIssue[];
  issues?: UserCsvImportApiIssue[];
  rowErrors?: UserCsvImportApiIssue[];
  fileErrorCode?: string;
  errorCode?: string;
  data?: Omit<UserCsvImportApiResponse, 'data'>;
}

export interface UserCsvImportApiIssue {
  line?: number | string;
  lineNumber?: number | string;
  field?: string;
  email?: string;
  code?: string;
  errorCode?: string;
}

/*
rolesOptions = [
    { label: "Mesa compra", value: Role.DESK_BUY, select: false },
    { label: "", value: Role.SELLER, select: false },
    { label: "Avaliador", value: Role.EVALUATOR, select: false },
  ];



*/

/*

Usuários de captação são os seguintes roles: ADMIN, DESK_BUY, SELLER, SELLER_MANAGER, EVALUATOR
Usuários de venda são os seguintes roles: OEM_DEALER, ADMIN, ,, OEM_DEALER_MANAGER, REGISTERER
*/

export const OemDealerOptionsEval = [
  new OptionLabel("Admin", Role.ADMIN),
  new OptionLabel("Mesa de Compra", Role.DESK_BUY),
  new OptionLabel("Vendedor", Role.SELLER),
  new OptionLabel("Gerente de Compras", Role.SELLER_MANAGER),
  new OptionLabel("Avaliador", Role.EVALUATOR),
  new OptionLabel("Gerente da Unidade", Role.EVAL_DEALER_MANAGER),
  new OptionLabel("Super Avaliador", Role.SUPER_EVALUATOR)
];

export const OemDealerOptionsSeller = [
  new OptionLabel("Admin", Role.ADMIN),
  new OptionLabel("Cadastrador de arremate", Role.REGISTERER),
  new OptionLabel("Mesa de Compra", Role.DESK_BUY),
  new OptionLabel("Mesa de Venda", Role.DESK_SELL),
  new OptionLabel("Gerente do arrematante", Role.OEM_DEALER_MANAGER),
  new OptionLabel("Gerente do pátio", Role.LOCATION_MANAGER)
];

export enum RoleEnumNames {
  REGISTERER = "Cadastrador de arremate",
  USER = "USUÁRIO",

  ADMIN = "Admin",

  // arremate
  DEALER = "Arrematante",
  DESK_SELL = "Mesa de Venda",
  OEM_DEALER_MANAGER = "Gerente do arrematante",
  LOCATION_MANAGER = "Gerente do pátio",

  // avaliar
  EVALUATOR = "Avaliador",
  SELLER = "Vendedor",
  DESK_BUY = "Mesa de Compra",
  SELLER_MANAGER = "Gerente de Compras",
  EVAL_DEALER_MANAGER = "Gerente da unidade",
  SUPER_EVALUATOR = "Super Avaliador"

}

export enum RoleTypeEnum {
  "OEMDEALER_SELL" = "OEMDEALER_SELL",
  "OEMDEALER_EVAL" = "OEMDEALER_EVAL",
  "OEMDEALER_ALL" = "OEMDEALER_ALL",
  "DEALER" = "DEALER",
  "ADMIN" = "ADMIN",
  "ALL" = "ALL",
}
